import React from 'react';
import propTypes from 'prop-types';

import './index.css';

OrderInfo.propTypes = {
  order: propTypes.object.isRequired
};

export default function OrderInfo(props) {
  let {order} = props;

  return (
    <div className='component-order-info'>
      <City className='begin' name={order.city_cn} date={order.from_date} />
      <div className='days'>
        <div><i className='icon icon-swap-right' /></div>
      </div>
      <City className='end' name={order.dropoff_city_cn} date={order.to_date} />
    </div>
  );
}



City.propTypes = {
  name: propTypes.string.isRequired,
  date: propTypes.string
};

City.defaultProps = {
  date: ''
};

function City(props) {
  let {name, date, className} = props;

  return (
    <div className={className}>
      <strong>{name}</strong>
      <br />
      <small>{date.substring(5)}</small>
    </div>
  );
}




// WEBPACK FOOTER //
// ./src/components/OrderInfo/index.js